<div class="holder">
  <div class="label">{{ label() }}</div>
  <div class="number">
    <div class="plus-minus value">{{ plusMinus() }}</div>
    <div [class]="{'summary': summary()}"
         class="value">{{ value() | number : '1.' + decimals() + '-' + decimals(): 'sv' }}
    </div>
  </div>
</div>
